import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupBy',
  standalone: true,
})
export class GroupByPipe implements PipeTransform {
  transform<T>(array: T[], property: keyof T): { [key: string]: T[] } {
    if (!Array.isArray(array) || !property) {
      return {};
    }

    return array.reduce(
      (acc, obj) => {
        const key = obj[property] as unknown as string;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      },
      {} as { [key: string]: T[] },
    );
  }
}
